<template>
  <el-dialog
    title="文件导入"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="close"
    width="640px"
  >
    <div class="dialog_box">
      <el-form
        ref="ruleForm"
        
        :model="dataInfo"
        label-width="0px"
      >
        <div class="list">
          <div class="uploaddesc">
            <div>
              支持（.xlsx 类型）文件导入
            </div>
            <div class="uploadtxt">
              <el-upload
                class="upload-demo"
                action=""
                :show-file-list="false"
                :before-upload="uploadVideo"
               :http-request="uploadFile"
              >
                <span>导入文件</span>

              </el-upload>

            </div>
          </div>
          <div slot="tip" class="el-upload__tip">只能上传xlsx格式文件</div>
          <div class="list-li" style="justify-content:center;  margin: 30px 0 70px;">
               <div v-if="!fileName">
                    <img class="uploadImg" src="~@/assets/uploadVideo.png" alt="">
                  <div slot="tip" style="text-align:center;" class="el-upload__tip">请先导入文件</div>

                </div>
            <div v-if="fileName" class="videoFlexBox">
               
                
              <div   class="videoPreview">
               <img src="~@/assets/excelPreview.png" alt=""> 
               <div>
                 <p> {{ fileName }}</p>
                  <span>(.xlsx)</span>
               </div>
               
              </div>
            </div>
          </div>
       
        </div>
      </el-form>
      <div slot="footer" class="dialog_save_cancel_box">
        <el-button class="" size="medium"   @click="close">取消</el-button>
        <el-button type="primary" :loading="loading" size="medium" class="" style="background: #416FFF;border:1px solid #416FFF" @click="saveClick('ruleForm')">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import qrService from '@/service/qrService'

//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    dialogType: {
      type: String,
      default: () => {
        return "add";
      }
    },
 
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      showDialog: false,
      fileName:"",
      file:undefined,
      loading:false
    };
  },
  //监控data中的数据变化
  watch: {
  
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    init(){
      this.fileName=''
      this.file=undefined
      this.showDialog = true;

    },
    uploadVideo(val) {
      console.log(val)
      if(val.name.includes('xls')){
        return true
      }else{
        this.$message.warning('请上传xlsx后缀文件')
          return false

      }
      // console.log(fileUpload,3334)
      // var fileUpload = event.target.files[0];
     
      // this.fileUploadCos(fileUpload,1)
    },
    async fileUploadCos(event,num) {
      // console.log(event,22)
      let file = event;
      // let uploadResult = await this.$Common.fileUploadCos(file);
      let uploadResult = await this.$Common.fileUploadCosGrid(file);

      
      if (uploadResult.err) {
        this.$message.error('上传出错，请联系管理员')
             this.dataInfo.videoUrl = "";
      } else {
        console.log('上传成功', uploadResult.data);
         this.fileName=     uploadResult.data.Key
          this.dataInfo.videoUrl = "https://" + uploadResult.data.Location;
        
      }
    },
    async uploadFile(val) {
      // let res = await this.$Common.fileUploadTencent(event);
      // console.log(res)
      // this.dataInfo.fileUrl = res.fileUrl;

      let fileUpload = val.file;
      this.file= val.file
      this.fileName = val.file.name
      // console.log(fileUpload,3334)
      // var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      // console.log(event.target.files,1111111111)
      // console.log(fileUpload,1111111112)
      // console.log(val.target.files[0],1111111113)
      // this.fileUploadCos(fileUpload,2)
    },
    close() {
        this.$refs.ruleForm.resetFields();
        this.showDialog = false;
    },
    async saveClick() {
      if(!this.fileName) return  this.$message({
          message:'请上传xlsx后缀文件',
          type: "warning"
        });
        let req = {
          file:this.file
        }
        this.loading=true
       let res = await qrService.exportQrCode(req,true);
      if (res.code == 200) {
        this.loading=false
        this.$message({
          type: "success",
          message: "导入成功!"
        });
        this.showDialog = false;
        this.$emit("searchData");
      } else if (res.code == 101) {
          this.loading=false

      } else {
          this.loading=false
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },  
    async uploadPrincipalClass() {
      let req = this.dataInfo;
      let res = await this.$Http.upReviewVideo(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
        this.showDialog = false;
        this.$emit("searchData", this.dataInfo);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async editPrincipalClass() {
      let req = this.dataInfo;
      let res = await this.$Http.updateReviewVideo(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功!"
        });
        this.showDialog = false;
        this.$emit("searchData", this.dataInfo);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.list {
  width: 100%;
  .list-li {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .li-label {
      height: 38px;
      width: 80px;
      flex: 0 0 80px;
      color: #000000;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
    .require {
      font-size: 14px;
      font-weight: 400;
      color: #FF3A3A;
    }
  }
}
.upload-demo{
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.uploadImg{
  width: 100px;
height: 100px;
margin: 0 auto;
}
.uploaddesc{
  display: flex;
  color: #000000;
  font-size: 12px;
  justify-content: space-between;
border-bottom: 1px dashed #D8D8D8;
padding: 10px 0; 
  span{
    color: #416FFF;
  }
}
/deep/.el-dialog{
  border-radius: 8px;
}
.dialog_save_cancel_box{
  height: 32px;
}
.dialog_box{
  padding: 10px 10px 0 10px;
}

.videoPreview{

width: 280px;
height: 54px;
border-radius: 4px;
opacity: 1;
	
background: #FFFFFF;
	
box-sizing: border-box;
/* 描边色/描边浅色 */
border: 1px solid #D8D8D8;
display: flex;
align-items: center;
padding: 0 12px;
font-size: 12px;
color: rgba(43, 61, 82, 0.6);
  img{
    width: 30px;
    margin-right: 10px;
height: 30px;
  }
  p{
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
          width: 200px;
    display: block;
    margin: 0;
    font-size: 13px;
    color: #3D3D3D;
            white-space: nowrap;
  }
}

.videoFlexBox{
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
</style>